import React from 'react'
import { Jumbotron, Container } from 'react-bootstrap' 

export default function About() {
    return (
        <div>
            <Jumbotron className="jumbotitle">
                <Container>
                <h3 className="abouttitle">
            <center><u>IsoPort Chambers Pvt. Ltd</u></center>
            </h3>
            </Container>
            </Jumbotron>
            <Jumbotron className="jumboabout">
                <Container>
                <h4 className="about">
            "IsoPort is developing a Real-time Health System (RTHS) driven by secure cloud  IoT with Big Data Analytics to evaluate both dynamic and static data for predictive analytics as part of a comprehensive healthcare system improvement program."
            </h4>
            </Container>
            </Jumbotron>
        </div>
    )
}
